._container_zvi61_1 {
  width: 100%; }

._enabled_zvi61_4 {
  width: 100%; }

._disabled_zvi61_7 {
  filter: grayscale(1);
  width: 100%;
  opacity: 0.8; }

._overlay_zvi61_12 {
  position: absolute;
  background: rgba(51, 56, 83, 0.48);
  border-radius: 11px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: all;
  border: solid 1px rgba(51, 56, 83, 0.48);
  padding-bottom: -1px;
  display: flex;
  justify-content: center;
  align-items: center; }

._enableMessage_zvi61_28 {
  width: 180px;
  border-radius: 12px;
  background-color: white;
  padding: 10px;
  text-align: center;
  gap: 10px; }
